module.exports = __webpack_public_path__ + "static/netflix-tudum-1-15c8e971908ff8ff16a45d179976db30.jpg";